/* eslint-disable no-case-declarations */
import { types } from "../type";

const initialState = {
  toDate: "",
  fromDate: "",
  locationId: "",
  sendMail: false,
  dataFormat: "ABP",
  foundManagers: [],
  reportingError: "",
  reportingStatus: 0,
  convertByTime: false,
  reportingMangerId: "",
  reportingResponse: "",
  reportingLoading: false,
  attendanceSheetReports: [],
  reportingCreateLoading: false,
  reportingEmployeesByLocation: []
};

const reportingReducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.ReportingTypes.REPORTINGS_SET_LOADING:
      return {
        ...state,
        reportingLoading: payload
      };
    case types.ReportingTypes.REPORTINGS_SET_CREATE_LOADING:
      return {
        ...state,
        reportingCreateLoading: payload
      };
    case types.ReportingTypes.REPORTINGS_CLEAR_ERRORS:
      return {
        ...state,
        reportingError: ""
      };
    case types.ReportingTypes.REPORTINGS_GET_ERRORS:
      return {
        ...state,
        reportingLoading: false,
        reportingCreateLoading: false,
        reportingError: payload.data.message,
        reportingStatus: payload.status
      };
    case types.ReportingTypes.GET_REPORTING_EMPLOYEES_BY_LOCATION_ID:
      return {
        ...state,
        reportingLoading: false,
        reportingEmployeesByLocation: payload.relations
      };
    case types.ReportingTypes.GET_REPORTING_MANAGERS:
      return {
        ...state,
        reportingLoading: false,
        foundManagers: payload.foundManagers
      };
    case types.ReportingTypes.GET_ATTENDANCE_SHEET_REPORTS:
      return {
        ...state,
        reportingLoading: false,
        attendanceSheetReports: payload.foundAttendanceSheet
      };
    case types.ReportingTypes.SHEET_INPUTS:
      return {
        ...state,
        toDate: payload.toDate,
        fromDate: payload.fromDate,
        sendMail: payload.sendMail,
        dataFormat: payload.dataFormat,
        locationId: payload.locationId,
        convertByTime: payload.convertByTime,
        reportingMangerId: payload.reportingMangerId
      };
    default:
      return state;
  }
};

export default reportingReducer;
